/** Scale applied to the base marker artwork. Stored width remains compatible with saved maps. */
export function markerScale(width: number): number {
  return Math.max(0.8, Math.min(5, 0.75 + width / 12));
}
